module.exports = __webpack_public_path__ + "img/upward-bound-tavaria-smith.096ba85c.jpg";